import React from "react";
import Backdrop from "@material-ui/core/Backdrop";
import { makeStyles } from "@material-ui/core/styles";
import CircularProgress from "@material-ui/core/CircularProgress";

const LoadingComponent = (props) => {
  const classes = makeStyles((theme) => ({
    backdrop: {
      zIndex: 1301,
      color: "#fff",
    },
    loaderComp: {
      display: "flex",
      alignItems: "center",
      flexDirection: "column",
      justifyContent: "center",
    },
  }))();

  return (
    <Backdrop
      className={classes.backdrop}
      open={true}
      style={{ display: props.isLoading ? "" : "none" }}
    >
      <section className={classes.loaderComp}>
        <div>
          <CircularProgress color="secondary" />
        </div>
        <div> Loading </div>
      </section>
    </Backdrop>
  );
};

export default LoadingComponent;
